/** App-wide font stacks (Geist via @fontsource-variable). */
export const fontSans =
  '"Geist Variable", "Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

export const fontMono =
  '"Geist Mono Variable", "Geist Mono", ui-monospace, SFMono-Regular, Menlo, monospace';
